import React, { Component } from 'react';
import { Container, Row, Button, Label, Col, Input, FormGroup } from "reactstrap";
import { observer, inject } from 'mobx-react';
import DataWrapper from '../../../principal/containers/DataWrapper';
import FormDatePicker from '../../../comum/components/FormDatePicker';
import SelectFiltro from '../../../comum/components/SelectFiltro';
import Select from 'react-select';
import ModalForm from "../../../comum/components/ModalForm";
import Card from '../../../comum/components/Card';
import InputFiltro from '../../../comum/components/InputFiltro';
import FormInput from '../../../comum/components/FormInput';
import BootstrapTable from "react-bootstrap-table-next";
import FormSelect from '../../../comum/components/FormSelect';
import FormInputSimples from "../../../comum/components/FormInputSimples";
import CargaPatioDTCStore from '../stores/CargaPatioDTCStore';
import moment from 'moment';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CollapseItemTableIndicator } from "../../../comum/components/CollapseItemTableIndicator";
import { ModalContainer, ModalDialog } from 'react-modal-dialog';
import { IconeEditar, IconeDelete } from "../../../comum/components/Icones";
import { toast } from "react-toastify";

@inject('store')
@DataWrapper
@observer

export class CargaPatioDTC extends Component {

    constructor(props) {
        super(props)

        this.colunasPesquisa = [{
            dataField: 'Id',
            text: 'Id'
          }, {
            dataField: 'TipoDocumento',
            text: 'Tipo Doc.'
          }, {
            dataField: 'Operacao',
            text: 'Operação'
          }, {
            dataField: 'NomeNavio',
            text: 'Navio'
          }, {
            dataField: 'DataPrevAtracacao',
            text: 'Prev. Atrac.'
          }, {
            dataField: 'Solicitante',
            text: 'Solicitante'
          }, {
            dataField: 'DataCriacao',
            text: 'Data'
          }, {
            dataField: 'UsuarioCriacao',
            text: 'Usuário'
          }, {
            dataField: 'FlagValido',
            text: 'Válido'
          },{
            dataField: 'Acao',
            text: 'Ações',
            formatter: (col, row)=>this.renderBotoesLinha(col, row),
            editable: false 
          }
        ];

        this.colunasContainers = [
            {
                dataField: 'Cntr',
                text: 'Containers Adicionados',
                headerAttrs: {
                    hidden: true
                }
            }
        ];

        this.cadastroVazio = {
            id: 0,
            tipoDoc: 'CRP',
            operacao: '',
            despachante: 0,
            dataPrevAtraca: '',
            observacao: '',
            containers: []
        };

        this.state = {
            carregando: false,
            mostrarCadastro: false,
            cadastro: this.cadastroVazio,
            pesquisa: {
                operacao: '',
                tipo: 'T',
                container: ''
            },
            inputs: {
                container: ''
            },
            combos: {
                tipoDocs: [{Id: 'CRP', Texto: 'CRP - Carga Pátio'}, {Id: 'DTC', Texto: 'DTC - Documento Trânsito Container'}],
                operacoes: [{Id: 'XXX', Texto: 'Nome da Operação'}],
                despachantes: [{Id: 1, Texto: 'Nome do Despachante'}],
                tipoPedido: [
                    {Id: 'T', Texto: 'Todos'}, 
                    {Id: 'V', Texto: 'Válida'},
                    {Id: 'F', Texto: 'Inválida'}
                ]
            },
            resultadoPesquisa: []
        }

        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
        this.controller = new CargaPatioDTCStore();
        this.loginStore = this.props.store.loginStore;

    }

    can = (operacao, tarefa = "CargaPatioDtcB2B") => this.loginStore.can(tarefa, operacao)

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Carga Pátio e DTC");

        this.controller.obterOperacoes().then( response =>{
            
            let {status, data} = response;
            let operacoes = data.map(x=> {
                return {
                    Id: x.Viagem,
                    Texto: `${x.Viagem} - ${x.NavioNome}`
                };
            });

            this.setState({ combos: {...this.state.combos, operacoes}})
        });

        this.controller.obterDespachantes().then( response =>{
            
            let {status, data} = response;

            let despachantes = data.map(x=> {
                return {
                    Id: x.DspId,
                    Texto: `${x.ApelidoDespachante}`
                };
            });

            this.setState({ combos: {...this.state.combos, despachantes}})
        });

    }

    filtrar(){

        // console.log('PESQUISA: ', this.state.pesquisa);
        // return;

        console.log('FILTRAR');

        this.setState({ carregando: true});

        try{
            let request = this.controller.filtrarSolicitacoes(this.state.pesquisa.operacao, this.state.pesquisa.container, this.state.pesquisa.tipo)
            request.then(response => {
                let {status, data} = response;

                this.setState({ carregando: false, resultadoPesquisa: data});
                //console.log(data);
            })
            
        }catch(err){
            this.setState({carregando: false});
            console.log(err);
        }
        
    }

    handleChangeInputCntr(container){
        this.setState({ inputs: { container: container.toUpperCase() }});
    }
    
    handleChangeCadastro(observacao){
        this.setState({ cadastro: { ...this.state.cadastro, observacao }});
    }

    handleChangedataPrevAtraca(dataPrevAtraca){
        this.setState({ cadastro: { ...this.state.cadastro, dataPrevAtraca }});
    }

    handleChangeTipoDocumento(event){
        this.setState({ cadastro: { ...this.state.cadastro, tipoDoc: event.value }});
    }

    handleChangeOperacao(event){
        this.setState({ cadastro: { ...this.state.cadastro, operacao: event.value }});
    }

    handleChangeDespachante(event){
        this.setState({ cadastro: { ...this.state.cadastro, despachante: event.value }});
    }

    handleChangeOperacaoPesquisa(event){
        this.setState({ pesquisa: { ...this.state.pesquisa, operacao: event.value }});
    }

    handleChangeContainerPesquisa(container){
        this.setState({ pesquisa: { ...this.state.pesquisa, container: container.toUpperCase() }});
    }

    handleChangeTipoPesquisa(event){

        let tipo = event ? event.value : 'T';

        this.setState({ pesquisa: { ...this.state.pesquisa, tipo }});
    }

    handleClickAdicionarCntr(){
        let lista = this.state.cadastro.containers;
        lista.push({
            Cntr: this.state.inputs.container,
            Id: 0
        });

        this.setState({ inputs: { container: '' }, cadastro: { ...this.state.cadastro, containers: lista } });
    }

    handleClickNovaSolicitacao(){
        this.setState({mostrarCadastro: true, cadastro: this.cadastroVazio});
    }

    handleClickSalvar(){
        this.setState({mostrarCadastro: false, carregando: true});

        try{
            let request = this.controller.salvarSolicitacao(this.state.cadastro)
            request.then(response => {

                let {status, data} = response;

                if(status == 200 || status == 204){
                    this.setState({ carregando: false, cadastro: this.cadastroVazio});

                    toast.success("Solicitação salva com sucesso.", {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true
                    });

                }else{
                    throw `Erro ao salvar: ${data}`;
                }                
            });
            
        }catch(err){
            this.setState({carregando: false});

            toast.error("Ouve um problema com a solicitação.", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true
            });

            console.log('ERRO: ', err);
        }

    }

    handleClickInvalidar(id){
        console.log('INVALIDAR ', id);

        this.setState({carregando: true});

        try{
            let request = this.controller.invalidarSolicitacao(id)
            request.then(response => {

                let {status, data} = response;

                if(status == 200 || status == 204){

                    this.setState({carregando: false });

                    toast.success("Solicitação invalidada com sucesso.", {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true
                    });

                }else{
                    throw `Erro ao salvar: ${data}`;
                }                
            });
            
        }catch(err){
            this.setState({carregando: false});

            toast.error("Ouve um problema com a solicitação.", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true
            });

            console.log(err);
        }

    }

    handleClickEditar(id){
        this.setState({carregando: true});

        try{
            let request = this.controller.obterSolicitacao(id)
            request.then(response => {

                let {status, data} = response;

                if(status == 200 || status == 204){

                    console.log(data);

                    let cadastro = {
                        id: data.Id,
                        tipoDoc: data.CdTipoDocumento,
                        operacao: data.Operacao,
                        despachante: data.DspId,
                        dataPrevAtraca: data.DataPrevAtracacao,
                        observacao: data.Observacao,
                        containers: data.Cntrs ? data.Cntrs : []
                    };

                    this.setState({carregando: false, cadastro, mostrarCadastro: true});

                }else{
                    throw `Erro ao salvar: ${data}`;
                }                
            });
            
        }catch(err){
            this.setState({carregando: false});

            toast.error("Ouve um problema com a solicitação.", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true
            });

            console.log(err);
        }
    }

    renderFiltros(){
        return (
            <div className="form-wrapper">
                <Container fluid>
                    <Card className="tabela-container area-form pb-0">
                        <Row className="align-items-end">
                            <SelectFiltro titulo="Operação" xl={3} md={4} sm={6} xs={12}
                                itens={this.state.combos.operacoes}
                                objeto={this.state.pesquisa}
                                dado={'operacao'}
                                itensValor="Id" itensLabel="Texto"
                                onChange={(event) => this.handleChangeOperacaoPesquisa(event)}
                            />
                            <InputFiltro titulo="Container" xl={3} sm={6} xs={12}
                                uppercase={true}
                                onEnter={() => this.filtrar()}
                                objeto={this.state.pesquisa}
                                dado={'container'}
                                onChange={(event) => this.handleChangeContainerPesquisa(event.target.value)} 
                            />
                            <SelectFiltro titulo="Situação do Pedido" xl={3} md={4} sm={6} xs={12}
                                itens={this.state.combos.tipoPedido}
                                objeto={this.state.pesquisa}
                                dado={'tipo'}
                                placeholder={"Todos"}
                                //valor={this.state.pesquisa.tipo}
                                itensValor="Id" itensLabel="Texto"
                                onChange={(event) => this.handleChangeTipoPesquisa(event)} 
                            />
                            {/* <Select
                                placeholder={"Selecione"}
                                //className={`w-100 select-filtro ${this.props.className ? this.props.className : ""}`}
                                //isDisabled={this.props.bloqueado}
                                isClearable={false}
                                isSearchable={true}
                                //theme={theme => setTemaSeletor(theme)}
                                //onChange={this.props.onChange}
                                //noOptionsMessage={() => ("Não há opções")}
                                options={this.state.combos.tipoPedido}
                                value={this.state.pesquisa.tipo}
                            /> */}
                            <Button className="btn-com-bordas-primary btn-filtrar mb-4" onClick={() => this.filtrar()}>Filtrar</Button>
                        </Row>
                    </Card>
                </Container>
            </div>
        )
    }

    renderTabela(){

        const detalhesRow = {
            renderer: row => {

                console.log(row);

                return (
                    <Row>
                        <h1>Teste</h1>
                    </Row>
                );
            },
            showExpandColumn: true,
            expandByColumnOnly: true,
            expandHeaderColumnRenderer: () => "Containers",
            expandColumnPosition: 'right',
            expandByColumnOnly: true,
            onExpandAll: (isExpandAll, results, e) => {
                e.PreventDefault();
            },
            expandColumnRenderer: ({ expanded }) => {
                if (expanded) {
                    return (
                        <CollapseItemTableIndicator expanded={expanded}/>
                    );
                }
                return (
                    <CollapseItemTableIndicator expanded={expanded}/>
                );
            },
            
        };

        return (
            <div className="form-wrapper">
                <Container fluid className="text-center">
                    <BootstrapTable 
                        keyField='Id' 
                        bootstrap4
                        striped
                        bordered={false}
                        noDataIndication={"Nenhum registro encontrado."}
                        classes="tabela"
                        columns={this.colunasPesquisa}
                        data={ this.state.resultadoPesquisa } 
                        //expandRow={ detalhesRow }
                    />
                </Container>
            </div>
        )
    }

    renderCadastro(){
        return (
                this.state.mostrarCadastro &&
                <ModalForm 
                    className="tamanho-modal-1000"
                    onClickCancelar={()=> this.setState({ mostrarCadastro: false }) }
                    onClickSalvar={ ()=> this.handleClickSalvar() } 
                >
                    <Row>
                        <Col sm={12} md={7}>
                            <h1>Operação</h1>
                            <Row>
                                <FormSelect 
                                    titulo="Tipo Documento" sm={12} md={4}
                                    itens={this.state.combos.tipoDocs}
                                    objeto={this.state.cadastro}
                                    dado={'tipoDoc'}
                                    itensValor="Id" itensLabel="Texto"
                                    value={this.state.cadastro.tipoDoc}
                                    onChange={(event) => this.handleChangeTipoDocumento(event)} 
                                />
                                <FormSelect 
                                    titulo="Operação" sm={12} md={8}
                                    itens={this.state.combos.operacoes}
                                    objeto={this.state.cadastro}
                                    dado={'operacao'}
                                    itensValor="Id" itensLabel="Texto"
                                    onChange={(event) => this.handleChangeOperacao(event)} 
                                />
                            </Row>
                            <Row>
                                <FormDatePicker sm={12} md={4} 
                                    titulo="Data Prev. Atracação"
                                    uniqueId="dataPrevAtraca"
                                    onChange={ (date) => this.handleChangedataPrevAtraca(date) }
                                    date={ this.state.cadastro.dataPrevAtraca ? moment(this.state.cadastro.dataPrevAtraca) : null}
                                />
                                <FormSelect 
                                    titulo="Despachante" sm={12} md={8}
                                    itens={this.state.combos.despachantes}
                                    objeto={this.state.cadastro}
                                    dado={'despachante'}
                                    itensValor="Id" itensLabel="Texto"
                                    onChange={(event) => this.handleChangeDespachante(event)} 
                                />
                            </Row>
                            <Row>
                                <FormInputSimples 
                                    titulo="Observação" xs={12} sm={12} md={12} lg={12} xl={12}
                                    limiteMaximo={4000}
                                    type="textarea"
                                    dado={this.state.cadastro.observacao}
                                    onChange={(event) => { this.handleChangeCadastro(event.target.value) }} 
                                />
                            </Row>
                        </Col>
                        <Col sm={12} md={5}>
                            <h1>Containers</h1>
                            <Row>
                                <Col xs={12} sm={12} md={8} lg={8} xl={8}>
                                    <FormGroup>
                                        <Label>Container</Label>
                                        <Input 
                                            value= { this.state.inputs.container }
                                            onChange= { (event)=>{this.handleChangeInputCntr(event.target.value)}}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                                    <Label className="invisible">no title</Label>
                                    <Button 
                                        onClick={(event)=>{ this.handleClickAdicionarCntr() }}
                                        className="btn-secundary form-control"
                                    >
                                        Adicionar
                                    </Button>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <BootstrapTable 
                                        keyField='Cntr' 
                                        bootstrap4
                                        striped
                                        bordered={false}
                                        noDataIndication={"Nenhum container inserido."}
                                        classes="tabela"
                                        columns={this.colunasContainers}
                                        data={this.state.cadastro.containers} 
                                    />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </ModalForm>
        )
    }

    renderCarregamento(){
        return (
            this.state.carregando &&
            <ModalContainer zIndex={100}>
                <ModalDialog className="nosso-modal modal-margin">
                    <div className="text-center">
                        <h1>Aguarde por favor..</h1>
                        <FontAwesomeIcon icon="circle-notch" size={"2x"} className={"icone"} color={"#001C43"} spin />
                    </div>
                </ModalDialog>
            </ModalContainer>
        )
    }

    renderBotoesTopo(){
        return (
            this.can("A") &&
            <Container fluid>
                <Row className="text-right">
                    <Col xs={12} sm={12} md={12} >
                        <Button className="mb-1 btn-com-bordas-primary" onClick={()=> this.handleClickNovaSolicitacao()} >Nova Solicitação</Button>
                    </Col>
                </Row>
            </Container>
        )
    }

    renderBotoesLinha(col, row){
        return (
            <div>
                {
                    this.can("E") &&
                    (
                    <a onClick={() => this.handleClickEditar(row.Id)} >
                        <IconeEditar title={"Editar"} tamanho="lg" className="m-2" />
                    </a>
                    )
                }
                {
                    this.can("I") &&
                    (
                    <a onClick={() => this.handleClickInvalidar(row.Id)} >
                        <IconeDelete title={"Invalidar"} tamanho="lg" className="m-2" />
                    </a>
                    )
                }
            </div>
            
        )
    }

    render(){
        return (
            <div>
                {
                    this.renderCarregamento()
                }
                {
                    this.renderBotoesTopo()
                }
                {
                    this.renderFiltros()
                }
                {
                    this.renderTabela()
                }
                {
                    this.renderCadastro()
                }
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/modules/agendamento/cargapatiodtc/telas/CargaPatioDTC.js